import OwnableTheme from '@Theme';
import { CardElement } from '@stripe/react-stripe-js';
import React from 'react';
import styled from 'styled-components/native';

import { useCheckoutStore } from '~stores/checkout';

const Wrapper = styled.View`
  width: 100%;
  padding: 20px 20px 17px;
  margin-bottom: 30px;
  background-color: white;
  border-bottom-width: 1px;
  border-bottom-color: ${OwnableTheme.colors.grayInput};
`;

const StyledCardElement = () => {
  const { setCardDetailsComplete } = useCheckoutStore();

  return (
    <Wrapper>
      <CardElement
        onChange={({ complete }) => {
          setCardDetailsComplete(complete);
        }}
        options={{
          hidePostalCode: true,
          hideIcon: true,
          iconStyle: 'solid',
          style: {
            base: {
              color: OwnableTheme.colors.black,
              fontSize: OwnableTheme.fontSizes.xs,
              padding: '20px',
              '::placeholder': {
                color: OwnableTheme.colors.gray,
              },
            },
            empty: {
              color: OwnableTheme.colors.black,
            },
            complete: {
              color: OwnableTheme.colors.black,
            },
            invalid: {
              color: OwnableTheme.colors.errorRed,
            },
          },
        }}
      />
    </Wrapper>
  );
};

export default StyledCardElement;
